var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"content-area"},[_c('base-header',{attrs:{"menu-listing":_vm.menuListing},on:{"sidemenu":function($event){return _vm.$emit('responsiveSideBar')}}}),_c('div',{staticClass:"right-panel"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }